import { CookieNotice } from "@/components/popups/CookieNotice";
import { setCookieNotice } from "@/common/utils/storage";
import { onCloseCookieNotice } from "@/components/popup-dispatcher/PopupDispatcher";
import { useCallback } from "react";

export const CookieNoticeWrapper = (): JSX.Element => {
  const onOK = useCallback(() => {
    setCookieNotice("ok");
    onCloseCookieNotice();
  }, []);

  const onCancel = useCallback(() => {
    setCookieNotice("cancel");
    onCloseCookieNotice();
    window.location.reload();
  }, []);

  return <CookieNotice onOK={onOK} onCancel={onCancel} />;
};
